import { MsalProvider } from '@azure/msal-react'
import React from 'react'
import ReactDOM from 'react-dom/client'

import App from 'App'
import { b2cInstance } from 'auth/authConfigB2C'
import { AppProviders } from 'providers/AppProviders'
import reportWebVitals from 'reportWebVitals'
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <MsalProvider instance={b2cInstance}>
      <AppProviders>
        <App />
      </AppProviders>
    </MsalProvider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
